const savedSearchItemSortOrders = {
    NEWLY_LISTED: 'newlyListed',
    STARTING_SOONEST: 'starting',
} as const;

export default savedSearchItemSortOrders;
